import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import styles from '../../Modal/themedModal.module.css';

export const ExpandModal = ({
  isOpen,
  title,
  onClose,
  children,
}: PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  title: string;
}>) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent className={styles.content} height="80%">
        <ModalHeader className={styles.header}>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
};
